/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

import './cyber-security-training.less';
import './cyber-security-training.mobile.less';
import './cyber-security-training.en.less';

import './landing/landing-course-section.less';
import './landing/landing-course-section.moblie.less';

import PageLayout from './layout';

import { useStore } from './store';
import LandingCourseSection from './landing/landing-course-section';
import OrgSection from './landing/organization-section';
import ResourcesSection from './landing/resources-section';
import AboutSection from './landing/about-section';
import IntroducingSection from './landing/introducing-section';
import HeaderSection from './landing/header-section';
import HotTopicSection from './landing/hot-topic-section';
import HotTopicMobileSection from './landing/hot-topic-mobile-section';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import NavSection from './landing/nav-section';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';

interface ICyberSecurityTrainingProps {}

const CyberSecurityTraining: React.FunctionComponent<
  ICyberSecurityTrainingProps
> = (props) => {
  const [checkedList, setCheckedList] = React.useState<string[]>([]);

  const [currentSlide, setCurrentSlide] = React.useState(0);

  const handleCheckedListChange = React.useCallback(
    (list: CheckboxValueType[]) => {
      const stringList = list.map((value) => String(value));
      setCheckedList(stringList);
    },
    []
  );

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    console.log('Checked List:', checkedList);
  }, [checkedList]);
  const scollToCourseRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const scollToCybersecRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const scollToIntroRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;

  const { initPageSettings, page } = useStore();
  const gotoIntro = () => {
    if (scollToIntroRef && scollToIntroRef.current) {
      const divHTML = scollToIntroRef?.current as HTMLDivElement;
      divHTML?.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const gotoAbout = () => {
    if (scollToCybersecRef && scollToCybersecRef.current) {
      const divHTML = scollToCybersecRef?.current as HTMLDivElement;
      divHTML?.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const gotoCourse = () => {
    if (scollToCourseRef && scollToCourseRef.current) {
      const divHTML = scollToCourseRef?.current as HTMLDivElement;
      divHTML?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scollTo = (sectionName: string) => {
    switch (sectionName) {
      case 'intro':
        gotoIntro();
        break;
      case 'about':
        gotoAbout();
        break;
      case 'course':
        gotoCourse();
        break;
      default:
        break;
    }
  };

  const [playFlag, setPlayFlag] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => {
      const scrollTop = document.querySelector('html')?.scrollTop || 0;
      const h =
        document.querySelector<HTMLElement>('.branding-section-container')
          ?.offsetHeight || 0;
      if (scrollTop >= h - window.innerHeight / 2) {
        setPlayFlag(true);
      }
    };
    if (!playFlag) {
      document.addEventListener('scroll', onScroll, { passive: true });
    }
    return () => window.removeEventListener('scroll', onScroll);
  });
  initPageSettings();
  if (!page) {
    return <div>Loading...</div>;
  }

  const { landing: settings } = page;

  const handlePrevSlide = () => {
    setCurrentSlide((prevSlide: any) => prevSlide - 1);
  };

  const handleNextSlide = () => {
    setCurrentSlide((prevSlide: any) => prevSlide + 1);
  };

  const hotTopicSections = settings?.HotTopicSections || [];

  const currentHotTopic = hotTopicSections.slice(
    currentSlide,
    currentSlide + 1
  );
  return (
    <div>
      <PageLayout pageName="landing-page" noHeader={true}>
        <HeaderSection
          settings={settings}
          scrollTo={scollTo}
          onCheckedListChange={handleCheckedListChange}
        />
        <IntroducingSection
          scrollRef={scollToIntroRef}
          playFlag={playFlag}
          settings={settings}
        />
        <div ref={scollToCourseRef} className="hottopic-section-container">
          <div
            className={
              window.innerWidth > 1024
                ? 'hottopic-section-header'
                : 'hottopic-mobile-section-header'
            }
            dangerouslySetInnerHTML={{
              __html: settings?.HotTopicSectionsTitle,
            }}
          />
          <div
            className={
              window.innerWidth > 1024
                ? 'hottopic-section-body'
                : 'hottopic-mobile-section-body'
            }
          >
            <div
              className={
                window.innerWidth > 1024
                  ? 'hot-topic-button'
                  : 'hot-topic-mobile-button previous'
              }
            >
              {currentSlide > 0 && (
                <button
                  className="previous hot-topic-btn"
                  type="button"
                  onClick={handlePrevSlide}
                >
                  <LeftOutlined />
                </button>
              )}
            </div>

            {currentHotTopic.map((HotTopicSections: any, idx: number) =>
              window.innerWidth > 1024 ? (
                <HotTopicSection
                  key={idx}
                  HotTopicSections={HotTopicSections}
                />
              ) : (
                <HotTopicMobileSection
                  key={idx}
                  HotTopicSections={HotTopicSections}
                />
              )
            )}

            <div
              className={
                window.innerWidth > 1024
                  ? 'hot-topic-button'
                  : 'hot-topic-mobile-button next'
              }
            >
              {currentSlide < hotTopicSections.length - 1 && (
                <button
                  className="next hot-topic-btn"
                  type="button"
                  onClick={handleNextSlide}
                >
                  <RightOutlined />
                </button>
              )}
            </div>
          </div>
        </div>
        <div ref={scollToCourseRef} className="course-section-container">
          <div
            className="course-section-header"
            dangerouslySetInnerHTML={{
              __html: settings?.courseSectionTitle,
            }}
          />
          <div className="course-section-body">
            <NavSection
              settings={settings}
              onCheckedListChange={handleCheckedListChange}
            />
            <div className="course-section-body-right">
              {settings?.courseSections &&
                settings.courseSections
                  .filter(
                    (courseSection: any) =>
                      courseSection.page === 'general-staff'
                  )
                  .map((courseSection: any, idx: number) => (
                    <LandingCourseSection
                      key={idx}
                      courseSection={courseSection}
                      settings={settings}
                    />
                  ))}
              {settings?.courseSections &&
                settings.courseSections
                  .filter(
                    (itm: any) =>
                      checkedList.includes(itm.filterName) && !itm.hide
                  )
                  .map((courseSection: any, idx: number) => (
                    <LandingCourseSection
                      key={idx}
                      courseSection={courseSection}
                      settings={settings}
                    />
                  ))}
            </div>
          </div>
        </div>
        <AboutSection settings={settings} scrollRef={scollToCybersecRef} />
        <ResourcesSection settings={settings} />
        {process.env.REACT_APP_DOMAIN === 'HKIRC' ? (
          <OrgSection settings={settings} />
        ) : null}
      </PageLayout>
    </div>
  );
};

export default CyberSecurityTraining;
